import { api } from '@/lib/api';
import type { TeamUserWithPresence, TeamChatMessagesResponse, TeamChatUploadResponse } from '@troia-v3/types';

export const teamChatService = {
  listUsers: async (): Promise<TeamUserWithPresence[]> => {
    const response = await api.get('internal-chat/users');
    return response.data.data.users;
  },

  getMessages: async (targetUserId: string, limit = 100): Promise<TeamChatMessagesResponse> => {
    const response = await api.get(`internal-chat/room/${targetUserId}`, {
      params: { limit },
    });
    return response.data.data;
  },

  uploadFile: async (targetUserId: string, formData: FormData): Promise<TeamChatUploadResponse> => {
    const response = await api.post(`internal-chat/room/${targetUserId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },
};
